import { createContext, useContext } from 'react';

type ProductServices = {
    updateCache: (product: any) => void;
};

const ActiveProductServicesContext = createContext<ProductServices>({
    updateCache: () => {},
});

export const ActiveProductServicesProvider = ActiveProductServicesContext.Provider;

export const useActiveProductServices = (): ProductServices =>
    useContext(ActiveProductServicesContext);
